<template>
  <div class='h100vh-100'>
    <div class="h-toolbarBg">
      <ejs-toolbar>
        <e-items>
          <!--<div v-if='exportFlag'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-add" title='导出模板'/></div>-->
          <!--<div v-if='btns.upgrade'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-upload" :title='$t("DeployManagement.upgradeBtn")' @click='upFun'/></div>-->
          <!--<div v-if='btns.back'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-previous-layer" :title='$t("DeployManagement.rebackBtn")' @click='backFun'/></div>-->
          <!--<div v-if='btns.expand'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-add" :title='$t("DeployManagement.expensionBtn")' @click='expandFun'/></div>-->
          <!--<div><button class="e-btn e-tbar-btn icon hero-icon hero-icon-remove" :title='$t("Alarm.remove")' @click='deleteFun'/></div>-->
          <!--<div><button class="e-btn e-tbar-btn icon hero-icon hero-icon-start-up" :title='$t("DeployManagement.rerunBtn")' @click='reRunFun'/></div>-->
          <!--<div><button class="e-btn e-tbar-btn icon hero-icon hero-icon-refresh" :title='$t("Alarm.refresh")' @click='refreshGridData'/></div>-->
          <e-item v-if='uploadBoolean' prefixIcon='icon hero-icon hero-icon-upload' :tooltipText='$t("DeployManagement.upgradeBtn")' :click='upFun'></e-item>
          <e-item v-if='rebackBoolean' prefixIcon='icon hero-icon hero-icon-previous-layer' :tooltipText='$t("DeployManagement.rebackBtn")' :click='backFun'></e-item>
          <e-item v-if='expensionBoolean' prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("DeployManagement.expensionBtn")' :click='expandFun'></e-item>
          <e-item v-if='removeBoolean' prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Alarm.remove")' :click='deleteFun'></e-item>
          <e-item v-if='rerunBoolean' prefixIcon='icon hero-icon hero-icon-start-up' :tooltipText='$t("DeployManagement.rerunBtn")' :click='reRunFun'></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click='refreshGridData'></e-item>
          <!--<e-item prefixIcon='icon hero-icon hero-icon-upload' :tooltipText='$t("DeployManagement.upgradeStatus")' :click='qryInfos'></e-item>-->
        </e-items>
      </ejs-toolbar>
      <div class='h-inputBox'>
        <input class='e-input' :placeholder='$t("DeployManagement.inputPlaceholder_nename")' @keyup.enter='filter' v-model='keyword' maxLength='30' />
      </div>
    </div>
    <div class='h100-40 noPage'>
      <!--<ejs-grid ref='grid' :dataSource="data" :allowResizing='true' height="calc(100% - 0px)">-->
        <!--<e-columns>-->
          <!--<e-column type='checkbox' headerText='id' minwidth='30' textAlign='Center'></e-column>-->
          <!--<e-column field='state' :headerText="$t('状态')" width='150' textAlign='Center'></e-column>-->
          <!--<e-column field='name' :headerText="$t('名称')" width='150' textAlign='Center'></e-column>-->
          <!--<e-column field='category' :headerText="$t('服务类别')" width='150' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>-->
          <!--<e-column field='deliveryType' :headerText="$t('交付类型')" width='150' textAlign='Center'></e-column>-->
          <!--<e-column field='descripe' :headerText="$t('介绍')" width='150' textAlign='Center'></e-column>-->
          <!--<e-column field='createTime' :headerText="$t('上架时间')" width='150' textAlign='Center'></e-column>-->
          <!--<e-column field='version' :headerText="$t('版本')" width='150' textAlign='Center'></e-column>-->
          <!--<e-column field='runEnvironment' :headerText="$t('部署环境')" width='150' textAlign='Center'></e-column>-->
          <!--<e-column field='id' :headerText="$t('操作')" width='150' textAlign='Center' :template='detailTemplate'></e-column>-->
        <!--</e-columns>-->
      <!--</ejs-grid>-->
      <Table ref="grid"></Table>
    </div>
    <!--<ejs-pager ref="grpPager" @click='getGridData(node)' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount'></ejs-pager>-->
    <CustomDialog ref='serDlg' :element='serDlg.element' :styles='styles'>
      <template v-slot:dialog-content>
        <ServerVersion ref='server'></ServerVersion>
      </template>
    </CustomDialog>
    <CustomDialog ref='deDlg' :element='deDlg.element' :styles='styles'>
      <template v-slot:dialog-content>
        <DeviceVersion ref='device'></DeviceVersion>
      </template>
    </CustomDialog>
    <CustomDialog ref='expandDlg' :element='expandDlg.element' :styles='styles'>
      <template v-slot:dialog-content>
        <ExpandCapacityDialog ref='expandCapacity'></ExpandCapacityDialog>
      </template>
    </CustomDialog>
    <!--<CustomDialog ref='deployedDetailPage' :element='dialog.eleDeployedDetailPage' :styles='dialog.styles'>-->
      <!--<template v-slot:dialog-content>-->
        <!--<DeployedDetailDialog ref='deployedDetail'></DeployedDetailDialog>-->
      <!--</template>-->
    <!--</CustomDialog>-->
    <CustomDialog ref='deployedDPDetailPage' :element='dialog.eleDeployedDPDetailPage' :styles='dialog.styles'>
      <template v-slot:dialog-content>
        <DeployedDPDetailDialog ref='deployedDPDetail'></DeployedDPDetailDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='deployed5GCDetailPage' :element='dialog.eleDeployed5GCDetailPage' :styles='dialog.styles'>
      <template v-slot:dialog-content>
        <Deployed5GCDetailDialog ref='deployed5GCDetail'></Deployed5GCDetailDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='expendPocPage' :element='dialog.eleExpendPocPage' :styles='dialog.styles'>
      <template v-slot:dialog-content>
        <ExpandPocDialog ref='expendPoc'></ExpandPocDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='upgradeInfoDialog' :element='dialog.eleUpgradeInfo' :styles='dialog.upgradeStyles'>
      <template v-slot:dialog-content>
        <UpgradeInfos ref='upgradeInfo'/>
      </template>
    </CustomDialog>
    <CustomDialog ref='templatePage' :element='dialog.ele5gcTemplate' :styles='dialog.upgradeStyles'>
      <template v-slot:dialog-content>
        <DeployCaseDialog ref="deployCase"/>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import detailTemplate from './DetailTemplate';
import ServerVersion from './ServerVersion';
import DeviceVersion from './DeviceVersion';
import ExpandCapacityDialog from './ExpandCapacityDialog';
import CustomDialog from '../../common/CustomDialog';
import { EventBus } from '../../../plugins/eventBus';
import HandlerResTool from './resHandlerCommon';
import Table from '../serverManagement/Table';
import Deployed5GCDetailDialog from './Deployed5GCDetailDialog';
import DeployedDPDetailDialog from './DeployedDPDetailDialog';
import ExpandPocDialog from './ExpandPocDialog';
import UpgradeInfos from "../runningEnvironment/DPEnviromentConfig/dialog/UpgradeInfos";
import DeployCaseDialog from "../serverManagement/deployCaseDialog";

export default {
  name: 'DeployedTable',
  props: [
    'exportFlag'
  ],
  data() {
    return {
      uploadBoolean:JSON.parse(sessionStorage.getItem('authMap')).ne_management.Upgrade,
      rebackBoolean:JSON.parse(sessionStorage.getItem('authMap')).ne_management.Switch,
      expensionBoolean:JSON.parse(sessionStorage.getItem('authMap')).ne_management.Expand,
      removeBoolean:JSON.parse(sessionStorage.getItem('authMap')).ne_management.Delete,
      rerunBoolean:JSON.parse(sessionStorage.getItem('authMap')).ne_management.Reboot,
      data: [],
      expandDataParam: {},
      btns: {
        upgrade: true,
        back: true,
        expand: true,
      },
      deliverMap: { // 交付方式 0:native 老的enb和epc包 / 1:image 镜像包 / 2:helm 5GC包
        0: 'native',
        1: 'image',
        2: 'helm'
      },
      envirMap: {
        1: 'DP',
        2: 'k8s',
        3: 'server',
        4: 'device'
      },
      neMap: {
        0: this.$t('System.neOAM'),
        3: this.$t('Topo.neMME'),
        4: this.$t('Topo.neHSS'),
        5: this.$t('Topo.nePGW'),
        6: this.$t('Topo.neSGW'),
        7: this.$t('Topo.nePCRF'),
        8: this.$t('Topo.neTCF'),
        9: this.$t('Topo.neTMF'),
        10: this.$t('Topo.nePDTGW'),
        11: this.$t('Topo.neDBS'),
        12: this.$t('Topo.neMC_CMS'),
        13: this.$t('Topo.neMC_CF'),
        14: this.$t('Topo.neMC_GMS'),
        15: this.$t('Topo.neMC_IDMS'),
        16: this.$t('Topo.neMC_PF'),
        17: this.$t('Topo.neBM_SC'),
        18: this.$t('Topo.neMBMS_GW'),
        19: this.$t('Topo.neFRS'),
        20: this.$t('Topo.neMC_TMF'),
        21: this.$t('Topo.nePRES'),
        23: this.$t('Topo.neP_HSS'),
        24: this.$t('Topo.neMC_KMS'),
        27: this.$t('Topo.neMCE'),
        28: this.$t('Topo.nePCDR'),
        31: this.$t('Topo.neDMS'),
        34: this.$t('Topo.neMC_GMS_NODE'),
        100: this.$t('Topo.neCU'),
        101: this.$t('Topo.neDU'),
        102: this.$t('Topo.neCU'),
        103: this.$t('Topo.neDU'),
        10001: this.$t('System.epcOAM'),
        10002: this.$t('System.imsOAM'),
        10003: this.$t('System.mcsOAM'),
        10004: this.$t('System.enodeb'),
        10007: this.$t('System.ibs_b'),
        10010: this.$t('System.ims_hytalk'),
        20001: this.$t('System.mcscl'),
        10009: this.$t('Topo.devgNB')
      },
      detailTemplate(args) {
        return {
          template: detailTemplate
        };
      },
      styles: {
        width: '810px',
        height: '752px',
        model: true,
        visible: false
      },
      serDlg: {
        element: {
          refName: "serDlg",
          isClose: true,
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: {
                content: `${this.$t("Common.close")}`
              }
            }
          ],
          title: this.$t('DeployManagement.serviceVerUpgrade')
        }
      },
      deDlg: {
        element: {
          refName: "deDlg",
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Common.cancel') } },
            {
              click: this.deConDlg,
              buttonModel: {
                content: `${this.$t("Common.confirm")}`,
                isPrimary: true
              }
            }
          ],
          title: this.$t('DeployManagement.deviceVerSwitch')
        }
      },
      expandDlg: {
        element: {
          refName: "expandDlg",
          isClose: true,
          buttonGroup: [
            { click: this.expandDialogHide, buttonModel: { content: this.$t('Common.cancel') } },
            {
              click: this.sendExpandDlg,
              buttonModel: {
                content: `${this.$t("Common.confirm")}`,
                isPrimary: true
              }
            }
          ],
          title: this.$t('DeployManagement.expensionBtn')
        }
      },
      dialog: {
        eleDeployedDPDetailPage: {
          target: this.$refs.deployedDPDetail,
          refName: 'deployedDetail',
          buttonGroup: [
            {
              click: this.closeDeployedDPDetailPage,
              buttonModel: { content: this.$t('SubscriberIms.cancel') }
            }
          ],
          title: this.$t('DeployManagement.detail'),
          isClose: true
        },
        eleDeployed5GCDetailPage: {
          target: this.$refs.deployed5GCDetail,
          refName: 'deployedDetail',
          buttonGroup: [
            {
              click: this.closeDeployed5GCDetailPage,
              buttonModel: { content: this.$t('SubscriberIms.cancel') }
            }
          ],
          title: this.$t('DeployManagement.detail'),
          isClose: true
        },
        eleExpendPocPage: {
          target: this.$refs.expendPoc,
          refName: 'deployedDetail',
          buttonGroup: [
            {
              click: this.closeExpendPocPage,
              buttonModel: { content: this.$t('SubscriberIms.cancel') }
            },
            {
              click: this.saveExpendPoc,
              buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true}
            },
          ],
          title: this.$t('DeployManagement.expensionBtn'),
          isClose: true
        },
        eleUpgradeInfo: {
          target: this.$refs.upgradeInfo,
          refName: 'upgradeInfo',
          buttonGroup: [
            {
              click: this.closeUpgradeInfoDialog,
              buttonModel: { content: this.$t('SubscriberIms.cancel') }
            },
          ],
          title: this.$t('DeployManagement.upgradeStatus'),
          isClose: true
        },
        ele5gcTemplate: {
          target: this.$refs.deployCase,
          refName: 'deployCase',
          buttonGroup: [
            {
              click: this.close5gcTemplateDialog,
              buttonModel: { content: this.$t('SubscriberIms.cancel') }
            },
            {
              click: this.save5gcTemplate,
              buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true}
            },
          ],
          title: this.$t('DeployManagement.configParams'),
          isClose: true
        },
        styles: {
          width: '55%',
          height: '80%',
          visible: false,
          model: true
        },
        upgradeStyles: {
          width: '55%',
          height: '80%',
          visible: false,
          model: true
        }
      },
      oper: undefined,
      param: undefined,
      reRunState: [21, 22],// 未运行 运行中
      keyword: undefined,
    };
  },
  methods: {
    getDeployedGrid(args) {
      const $this = this;
      // const temp = [{ idFlag: '1_1_1.0.1', state: 1, name: 'AMF', category: '1', deliveryType: '1', descripe: '这是测试的哈', createTime: '2020-04-03 14:37:02', version: '1.0.1', runEnvironment: '5gc运行环境' }];
      // $this.data = temp;
      const paramSend = {
        url: '/lte/ems/deployed/queryAll',
        config: {},
        formData: {

        },
        callFun: $this.initDataCallFun,
        load: this.param.load,
        $axios: this.param.$axios
      };
      $this.oper.$GetRequest(paramSend);
    },
    initDataCallFun(response) {
      const $this = this;
      const res = response.data;
      $this.data = res;
    },
    upFun() {
      const param = this.checkSame();
      if (param == null) {
        return null;
      }
      param['upOrBack'] = 0;
      // 1-dp 2-k8s 3-server 4-device
      const envType = param['dataSource'][0]['envType'];
      if (envType != 'BS') {
        if(param['dataSource'][0]['runStateValue'] == 20){
          this.eventEmit('warning', this.$t('DeployManagement.unUpgrade'));
          return false;
        }
        // 服务升级
        this.$refs.server.init(param);
        this.$refs.serDlg.show();
      } else {
        // 设备升级
        this.$refs.device.init(param);
        this.$refs.deDlg.show();
      }
    },
    qryInfos(){
      this.$refs.upgradeInfo.setUpgradeInfo({envId:2409,selected:[]});
      this.$refs.upgradeInfoDialog.show();
    },
    backFun() {
      const param = this.checkSame();
      if (param == null) {
        return null;
      }
      this.$layer.confirm({
        msg: this.$t('DeployManagement.backConfirm'),
        btn1: {
          msg: this.$t('MML.cancel')
        },
        btn2: {
          msg: this.$t('MML.confirm'),
          func:()=>{
            // 设备和服务不支持切换到任意版本
            param['upOrBack'] = 1;
            // 1-dp 2-k8s 3-server 4-BS
            const envType = param['dataSource'][0]['envType'];
            if (envType != 'BS') {
              if(param['dataSource'][0]['runStateValue'] == 20){
                this.eventEmit('warning', this.$t('DeployManagement.unRollBack'));
                return false;
              }
              // 服务回退
              this.$refs.server.init(param);
              // this.$refs.serDlg.show();
              this.$refs.server.changeVersion();
            } else {
              // 设备回退
              this.$refs.device.init(param);
              this.$refs.deDlg.show();
            }
          }
        }
      });

    },
    expandFun() {
       this.expandDataParam=this.$refs.grid.$refs.grid.getSelectedRecords()[0];
       // TODO:判断非D和poc微服务的实例运行环境，不支持扩容
        // D项目扩缩容
        // if(undefined!==this.expandDataParam.id){
          console.log("expandDataParam",this.expandDataParam);
      if (!this.expandDataParam) {
        this.eventEmit('warning', this.$t('Common.tips.selectOne'));
        return;
      }
      if(this.expandDataParam.envType === '5G'){
        this.$refs.expandCapacity.getJson(this.expandDataParam.id,this.expandDataParam.dname,this.expandDataParam.envID, (response) => {
        if(response){
           this.$refs.expandDlg.show();
          }
        else{
           this.eventEmit('warning', this.$t('DeployManagement.tips_noHasModExpansionParam'));
          }
      });//参数待定
      } else if(this.expandDataParam.envType === 'DP') {
        // poc微服务的扩容
        this.expandDataParam.dpCount = 1;
        this.expandDataParam.name = this.expandDataParam.typeValue?this.expandDataParam.typeValue.toLowerCase()+Math.random(1):"";
        this.$refs.expendPoc.initValue(this.expandDataParam);
        this.$refs.expendPocPage.show();
        this.$refs.expendPoc.bindValidate();
      } else {
        // EPC和老poc
        this.eventEmit('warning', this.$t('DeployManagement.expensionTip_nosupport'));
      }
    },
    deleteFun() {
      const record = this.$refs.grid.$refs.grid.getSelectedRecords()[0];
      if (!record) {
        this.eventEmit('warning', this.$t('Common.tips.selectOne'));
        return null;
      }
      this.$layer.confirm({
        msg: this.$t('Common.tips.confirmTip'),
        btn1: {
          msg: this.$t('System.cancel'),
        },
        btn2: {
          msg: this.$t('System.confirm'),
          func: this.delFun
        }
      });
    },
    delFun() {
      const param = this.$refs.grid.$refs.grid.getSelectedRecords()[0];
      const url = '/lte/ems/deployed/delete';
      this.$loading.showLoadding(this.$t('DeployManagement.deleteLoad'));
      this.$axios.post(url, param).then(res => {
        this.$loading.hideLoadding();
        // TODO:删除中，禁止其他操作？
        if (res.status !== 200) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
        } else {
          // if (param.envType === '5G') {
            if (res.data.errorCode === 'SUCCESS' || res.data.errorCode === '0' || res.data.errorCode === 0) {
              EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
              this.$refs.grid.init(0);
            } else {
              EventBus.$emit('toast', { type: 'warning', content: res.data.errorString });
            }
          // } else {
          //   if (res.data.errorCode === 'SUCCESS') {
          //     EventBus.$emit('toast', { type: 'success', content: this.$t('Track.success') });
          //     this.$refs.grid.init(0);
          //   } else {
          //     EventBus.$emit('toast', { type: 'warning', content: res.data.errorString });
          //   }
          // }
        }
      });
    },
    sendExpandDlg() {
      this.$refs.expandCapacity.saveProfile((response) => {
      this.expandDialogHide();
      });
    },
    checkSame() {
      // const record = this.$refs.grid.ej2Instances.getSelectedRecords();
      const record = this.getSelectRecords();
      if (record.length === 0) {
        this.eventEmit('warning', `${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      const obj = {};
      const serverType = record.reduceRight((item, next) => {
        obj[next.category] ? '' : obj[next.category] = true && item.push(next);
        return item;
      }, []);
      if (serverType.length > 1) {
        this.eventEmit('warning', this.$t('DeployManagement.pleaseSelSameType'));
        return null;
      }
      const param = {
        oamTypeCode: record[0]['oamTypeCode'],
        dataSource: record
      };
      return param;
    },
    deConDlg() {
      this.$refs.device.confirm();
    },
    dialogHide() {
      this.$refs.serDlg.clear();
      this.$refs.serDlg.close();
      this.$refs.deDlg.clear();
      this.$refs.deDlg.close();
    },
    expandDialogHide() {
      this.$refs.expandDlg.clear();
      this.$refs.expandDlg.close();
    },
    eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content});
    },
    // 获取grid选中的数据
    getSelectRecords() {
      const record = this.$refs.grid.$refs.grid.getSelectedRecords();
      return record;
    },
    openDeployedDetailPage(target) {
      if (target.envType === '5G') {
        this.$refs.deployed5GCDetailPage.show();
        this.$refs.deployed5GCDetail.query5GCDetailInfo(target);
      } else if(target.envType === 'DP') {
        this.$refs.deployedDPDetailPage.show();
        this.$refs.deployedDPDetail.queryDPDetailInfo(target);
      } else {
        this.$refs.deployedDPDetailPage.show();
      }
    },
    open5gcTemplate(target){
      this.$refs.deployCase.getJson(target.deployData);
      setTimeout(()=>{
        this.$refs.deployCase.getConfigJson(target.upgradeData);
      },1000);
      this.$refs.templatePage.show();
      this.$refs.deployCase.bindValidate();
    },
    close5gcTemplateDialog(){
      this.$refs.templatePage.clear();
      this.$refs.templatePage.close();
    },
    save5gcTemplate(){
      this.$layer.confirm({
        msg: this.$t('DeployManagement.templateConfirm'),
        btn1: { msg: this.$t('MML.cancel')},
        btn2: {
          msg: this.$t('MML.confirm'),
          func: ()=>{
            this.$refs.deployCase.updateTemplate((res) =>{
              if(res.errorCode == 'SUCCESS'){
                this.close5gcTemplateDialog();
                this.$refs.server.upgradeAfterConfig(res.data);
              }else{
                this.eventEmit('warn', res.errorString);
              }
            });
          }
        },
      });
    },
    closeDeployedDPDetailPage() {
      this.$refs.deployedDPDetailPage.clear();
      this.$refs.deployedDPDetailPage.close();
    },
    closeDeployed5GCDetailPage() {
      this.$refs.deployed5GCDetailPage.clear();
      this.$refs.deployed5GCDetailPage.close();
    },
    refreshGridData() {
      this.$refs.grid.init(0);
    },
    filter() {
      // 前台过滤
      console.log(this.keyword);
      this.$refs.grid.refreshData(this.keyword, ['dname']);
    },
    saveExpendPoc() {
      this.$refs.expendPoc.saveExpendPoc(this.getSelectRecords(), (response) => {
        if (this.responseIsFailed(response)) {
          return;
        }
        this.expandDataParam = undefined;
        this.closeExpendPocPage();
        EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
        this.refreshGridData();
      });
    },
    responseIsFailed(response) {
      if (response.status !== 200) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.requestResTip')});
        return true;
      }
      if (response.data && response.data.errorCode != "SUCCESS") {
        // EventBus.$emit('toast', {type: 'warning', content: response.data.errorString});
        EventBus.$emit('toast', {type: 'warning', content: response.data.errorString});
        return true;
      }
      return false;
    },
    closeExpendPocPage() {
      this.$refs.expendPocPage.clear();
      this.$refs.expendPocPage.close();
    },
    closeUpgradeInfoDialog() {
      this.$layer.confirm({
        msg: this.$t('DeployManagement.qryUpgradeInfo'),
        btn1: { msg: this.$t('MML.cancel')},
        btn2: {
          msg: this.$t('MML.confirm'),
          func: ()=>{
            this.$refs.upgradeInfoDialog.clear();
            this.$refs.upgradeInfoDialog.close();
          }
        },
      });
    },
    /**
     *（只有微服务支持该功能） 微服务重启----只支持运行中和已部署的服务
     */
    reRunFun() {
      const selectData = this.$refs.grid.$refs.grid.getSelectedRecords()[0];
      if (!selectData) {
        this.eventEmit('warning', this.$t('Common.tips.selectOne'));
        return;
      }
      if(selectData.envType === 'DP'){
        if (this.reRunState.includes(selectData.runStateValue)) {
          this.$layer.confirm({
            msg: this.$t('DeployManagement.returnComfirm'),
            btn1: { msg: this.$t('MML.cancel')},
            btn2: {
              msg: this.$t('MML.confirm'),
              func: this.reRunPod
            },
          });
        } else {
          this.eventEmit('warning', this.$t('DeployManagement.rerunTip_nosupport_status'));
        }
      } else {
        this.eventEmit('warning', this.$t('DeployManagement.rerunTip_nosupport_ne'));
      }
    },
    reRunPod() {
      this.$loading.showLoadding(this.$t('DeployManagement.rerunLoad'));
      const param = this.$refs.grid.$refs.grid.getSelectedRecords()[0];
      const url = '/lte/ems/deployed/reRunPod';
      param.runState = '----';
      this.$refs.grid.$refs.grid.setCellValue(param.id, 'runState', '----');
      this.$axios.post(url, param).then(res => {
        this.$loading.hideLoadding();
        if(!this.responseIsFailed(res)) {
          EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
          // this.$refs.grid.init(0);
        }
      });
    },

  },
  components: {
    DeployCaseDialog,
    UpgradeInfos,
    ExpandPocDialog,
    Deployed5GCDetailDialog,
    DeployedDPDetailDialog,
    ServerVersion,
    DeviceVersion,
    ExpandCapacityDialog,
    CustomDialog,
    Table,
    ExpandPocDialog
  },
  mounted() {
    this.oper = new HandlerResTool();
    this.param = {
      load: this.$loading,
      $axios: this.$axios
    };
  },
  created() {
    EventBus.$on('openDetailPage', target => {
      this.openDeployedDetailPage(target);
    });
    EventBus.$on('setUpgradeParam', target => {
      this.$refs.upgradeInfo.setUpgradeInfo(target);
      this.closeDeployedDPDetailPage();
      this.dialogHide();
      this.$refs.upgradeInfoDialog.show();
    });
    EventBus.$on('open5gcTemplate', target => {
      console.log("open5gcTemplate receive:", target);
      this.open5gcTemplate(target);
    });
  }
};
</script>

<style scoped>

</style>
